import { render, staticRenderFns } from "./RepositoriesTabContent.vue?vue&type=template&id=fd223c10&scoped=true&"
import script from "./RepositoriesTabContent.vue?vue&type=script&lang=js&"
export * from "./RepositoriesTabContent.vue?vue&type=script&lang=js&"
import style0 from "./RepositoriesTabContent.vue?vue&type=style&index=0&id=fd223c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd223c10",
  null
  
)

export default component.exports